import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "linkify",
    standalone: false,
})
export class LinkifyPipe implements PipeTransform {
    transform(value: string | undefined | null) {
        if (!value) {
            return "";
        }

        let replacedText;

        // URLs starting with http:// or https://
        const replacePattern1 =
            /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        replacedText = value.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

        // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
        const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText.replace(
            replacePattern2,
            '$1<a href="http://$2" target="_blank">$2</a>'
        );

        return replacedText;
    }
}
